// extracted by mini-css-extract-plugin
export default {"label":"ContractsFilterLabel_label__ND2Pv","smallLabel":"ContractsFilterLabel_smallLabel__A49Oy"};